
const subsidyCases = [
  {
    type: 'C類型-1の場合',
    plan: 'ECサイト作成',
    cost: 80,
    rate: '2/3',
    subsidy: 53,
    selfPay: 27,
    icon: 'ri-user-line',
    iconLabel: '経営者',
  },
  {
    type: 'C類型-2の場合',
    plan: 'ECサイト作成/サーバー構築/導入コンサルティング/保守運用サービス',
    cost: 600,
    rate: '3/4',
    subsidy: 450,
    selfPay: 150,
    icon: 'ri-palette-line',
    iconLabel: 'デザイナー',
  },
];

const ITSupportSubsidy = () => {
  return (
    <section className="py-20 bg-[#F8FBF6]">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-[#5DAA68] text-xs font-semibold tracking-[0.2em] uppercase mb-3 font-['Inter']">
            Subsidy Example
          </p>
          <h4 className="text-2xl md:text-3xl font-bold text-[#89B56B] font-['Noto_Sans_JP']">
              類型別の補助金例
          </h4>
        </div>

        <div className="space-y-8">
          {subsidyCases.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-[0_4px_24px_rgba(137,181,107,0.08)] p-8 md:p-10 hover:shadow-[0_8px_32px_rgba(137,181,107,0.15)] hover:-translate-y-1 transition-all duration-300"
            >
              <div className="text-center mb-2">
                <span className="inline-block bg-[#F8FBF6] text-[#3F6844] text-xs font-bold px-4 py-1.5 rounded-full">
                  {item.type}
                </span>
              </div>
              <p className="text-center text-[13px] text-gray-500 mb-8">{item.plan}</p>

              <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6">
                {/* 制作費用 */}
                <div className="flex flex-col items-center bg-[#F8FBF6] rounded-xl p-6 min-w-[160px]">
                  <span className="text-[11px] font-bold mb-2 bg-[#89B56B] text-white px-3 py-1 rounded-full">
                    制作費用
                  </span>
                  <p className="text-3xl font-bold text-[#3F6844]">
                    {item.cost}<span className="text-sm font-normal ml-1">万円</span>
                  </p>
                  <div className="mt-3 w-10 h-10 flex items-center justify-center text-[#89B56B]">
                    <i className={`${item.icon} text-2xl`}></i>
                  </div>
                  <span className="text-[11px] text-gray-500 mt-1">{item.iconLabel}</span>
                </div>

                {/* 矢印 + 補助率 */}
                <div className="flex flex-col items-center gap-1">
                  <div className="w-8 h-8 flex items-center justify-center text-[#89B56B]">
                    <i className="ri-arrow-right-line text-2xl hidden md:block"></i>
                    <i className="ri-arrow-down-line text-2xl md:hidden"></i>
                  </div>
                  <span className="text-[11px] text-gray-500">補助率</span>
                  <span className="text-xl font-bold text-[#3F6844]">{item.rate}</span>
                </div>

                {/* 補助額 */}
                <div className="flex flex-col items-center bg-[#89B56B]/10 rounded-xl p-6 min-w-[160px] border-2 border-[#89B56B]/30">
                  <span className="text-[11px] font-bold mb-2 bg-[#89B56B] text-white px-3 py-1 rounded-full">
                    補助額
                  </span>
                  <p className="text-3xl font-bold text-[#89B56B]">
                    {item.subsidy}<span className="text-sm font-normal ml-1">万円</span>
                  </p>
                  <div className="mt-3 pt-3 border-t border-[#89B56B]/20 w-full text-center">
                    <span className="text-[11px] font-bold text-white bg-[#5DAA68] px-3 py-1 rounded-full">
                      実質負担
                    </span>
                    <p className="text-xl font-bold text-[#5DAA68] mt-1">
                      {item.selfPay}<span className="text-sm font-normal ml-1">万円</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ITSupportSubsidy;
